import { Button, ModalBody, Modal, ModalHeader } from "reactstrap";
import "../../components/layout/Leads/Leads.scss";
import ModalCloseIcon from "../../images/modal-close.svg";
import { ReactNode } from "react";
interface IProps {
  confirmCloseHandle: (closeTag: string) => void;
  confirmCloseModel: boolean;
  confirmText: any;
  className?: string;
  headerText?: string;
  modalToggle?: () => void;
  firstBtn: string;
  secondBtn: string;
}

const TimerModal = (props: IProps) => {
  const closeBtn = (
    <button
      className="close"
      onClick={() => props.confirmCloseHandle(props?.secondBtn)}
      type="button"
    >
      <img src={ModalCloseIcon} alt="ModalCloseIcon" />
    </button>
  );
  return (
    <Modal
      isOpen={props.confirmCloseModel}
      className={`ToasterPopUp ${props.className}`}
      toggle={props.modalToggle}
    >
      {props.headerText && (
        <ModalHeader close={closeBtn}>{props.headerText}</ModalHeader>
      )}
      <ModalBody>
        <div className="options">
          <h4
            className={props?.headerText === "Session Expired" ? "header" : ""}
          >
            {props.confirmText}
          </h4>
          <Button
            className="yes"
            onClick={() => props.confirmCloseHandle(props?.firstBtn)}
          >
            {props?.firstBtn}
          </Button>
          <Button
            className="no"
            onClick={() => props.confirmCloseHandle(props?.secondBtn)}
          >
            {props?.secondBtn}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TimerModal;
